import { SimilarityScoreWeights } from '@aloft/toolkit-shared';

import {
  useGetTkv2OrderSimilarityScoreWeightsAPI,
  usePutTkv2OrderSimilarityScoreWeightsAPI,
} from '../../../hooks/api/toolkitComponents.ts';

type UseSimilarityScoreWeightsResult = {
  weights?: SimilarityScoreWeights;
  isLoading: boolean;
  save: (weights: SimilarityScoreWeights, saveAsDefault?: boolean) => Promise<void>;
  isSaving: boolean;
};

export const useSimilarityScoreWeights = (orderID: string): UseSimilarityScoreWeightsResult => {
  const { data, isLoading } = useGetTkv2OrderSimilarityScoreWeightsAPI({
    pathParams: { orderID },
  });

  const { mutateAsync, isPending: isSaving } = usePutTkv2OrderSimilarityScoreWeightsAPI();

  const save = async (weights: SimilarityScoreWeights, saveAsDefault = false) => {
    await mutateAsync({
      pathParams: { orderID },
      queryParams: saveAsDefault ? { saveAsDefault: 'true' } : undefined,
      body: weights,
    });
  };

  return {
    weights: data as SimilarityScoreWeights | undefined,
    isLoading,
    save,
    isSaving,
  };
};
